import { render, staticRenderFns } from "./LivingBody.vue?vue&type=template&id=5015c733&scoped=true&"
import script from "./LivingBody.vue?vue&type=script&lang=js&"
export * from "./LivingBody.vue?vue&type=script&lang=js&"
import style0 from "./LivingBody.vue?vue&type=style&index=0&id=5015c733&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5015c733",
  null
  
)

export default component.exports